import { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/firestore';
import './RSVP.scss';

const RSVP = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    numberOfGuests: '1',
    attending: '',
    mealPreference: '',
    dietaryRestrictions: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Save to Firestore
      await addDoc(collection(db, 'rsvps'), {
        ...formData,
        submittedAt: serverTimestamp()
      });

      // Send email notification
      await fetch('https://formsubmit.co/ajax/rajeshmaydev@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          _subject: `New RSVP from ${formData.name}`,
          _cc: 'indira02032001@gmail.com',
          _template: 'table',
          Name: formData.name,
          Email: formData.email,
          Phone: formData.phone,
          'Number of Guests': formData.numberOfGuests,
          Attending: formData.attending,
          'Meal Preference': formData.mealPreference,
          'Dietary Restrictions': formData.dietaryRestrictions || 'None',
          Message: formData.message || 'No message'
        })
      });

      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        numberOfGuests: '1',
        attending: '',
        mealPreference: '',
        dietaryRestrictions: '',
        message: ''
      });
    } catch (error) {
      console.error('Error submitting RSVP:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="rsvp-section section" id="rsvp">
      <div className="container">
        <h2 className="rsvp-title">RSVP</h2>
        <p className="rsvp-subtitle">We'd love to celebrate with you! Please let us know if you can make it.</p>

        {submitStatus === 'success' && (
          <div className="alert alert-success">
            <h3>Thank you for your RSVP! ♥</h3>
            <p>We've received your response and sent a confirmation to your email.</p>
          </div>
        )}

        {submitStatus === 'error' && (
          <div className="alert alert-error">
            <h3>Oops! Something went wrong.</h3>
            <p>Please try again or contact us directly.</p>
          </div>
        )}

        <form className="rsvp-form" onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Your name"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number *</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="+91 98765 43210"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="attending">Will you be attending? *</label>
              <select
                id="attending"
                name="attending"
                value={formData.attending}
                onChange={handleChange}
                required
              >
                <option value="">Please select</option>
                <option value="yes">Yes, I'll be there!</option>
                <option value="no">Sorry, can't make it</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="numberOfGuests">Number of Guests *</label>
              <select
                id="numberOfGuests"
                name="numberOfGuests"
                value={formData.numberOfGuests}
                onChange={handleChange}
                required
              >
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5+</option>
              </select>
            </div>
          </div>

          {formData.attending === 'yes' && (
            <>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="mealPreference">Meal Preference *</label>
                  <select
                    id="mealPreference"
                    name="mealPreference"
                    value={formData.mealPreference}
                    onChange={handleChange}
                    required={formData.attending === 'yes'}
                  >
                    <option value="">Please select</option>
                    <option value="vegetarian">Vegetarian</option>
                    <option value="non-vegetarian">Non-Vegetarian</option>
                    <option value="vegan">Vegan</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="dietaryRestrictions">Dietary Restrictions</label>
                  <input
                    type="text"
                    id="dietaryRestrictions"
                    name="dietaryRestrictions"
                    value={formData.dietaryRestrictions}
                    onChange={handleChange}
                    placeholder="Any allergies or special requirements?"
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message for the Couple (Optional)</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Share your best wishes..."
                ></textarea>
              </div>
            </>
          )}

          <button
            type="submit"
            className="btn btn-primary btn-submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Submitting...' : 'Submit RSVP'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default RSVP;
